import React, {Component} from 'react';
import {Col, FormGroup} from 'reactstrap';
import NewManual from 'manuals/components/NewManual';
import CategorySearch from 'manuals/components/CategorySearch';
import NewCategory from 'manuals/components/NewCategory';


export default class CategoryControls extends Component {
    render() {
        return (
            <FormGroup row className="mt-3">
                <Col sm={3}>
                    <CategorySearch/>
                </Col>
                <Col sm={6}>
                    <NewCategory/>
                    <NewManual/>
                </Col>
            </FormGroup>
        )
    }
}
